import { Component, input, signal, ChangeDetectionStrategy } from '@angular/core';

import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'inbox-copy-message-button',
  imports: [MatIcon, MatIconButton, MatTooltip, TranslateModule],
  templateUrl: './copy-message-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './copy-message-button.component.scss',
})
export class CopyMessageButtonComponent {
  readonly messageHtml = input.required<string>();
  readonly isCopied = signal(false);

  async copyMessage(): Promise<void> {
    const html = this.messageHtml();
    if (!html) {
      return;
    }
    const plainText = this.htmlToPlainText(html);
    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/html': new Blob([html], { type: 'text/html' }),
          'text/plain': new Blob([plainText], { type: 'text/plain' }),
        }),
      ]);
    } catch {
      await navigator.clipboard.writeText(plainText);
    }
    if (!this.isCopied()) {
      this.isCopied.set(true);
      window.setTimeout(() => {
        this.isCopied.set(false);
      }, 1200);
    }
  }

  private htmlToPlainText(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.innerText || div.textContent || '';
  }
}
